import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HOME } from "@/constants/testIds";

const VIDEO_URL = "https://customer-assets-jai6qajn.emergentagent.net/job_web-app-hub-36/artifacts/3z41i3oq_1st%20BBAP%20Video%20%28Female%20Narrator%29.mp4";

export default function ExplainerVideo() {
  return (
    <section className="bg-zinc-950 text-white py-16 border-b border-white/10">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#4FD1C5] mb-3">See BBAP In Action</p>
        <h2 className="font-display font-extrabold uppercase text-2xl md:text-3xl tracking-tight mb-4">
          Watch how the full platform works
        </h2>
        <p className="text-zinc-400 max-w-2xl mx-auto mb-8 leading-relaxed">
          This short explainer walks through BBAP end-to-end — documenting bias, building the data, and
          responding when it matters most. It's also our case for support: help us fund what's next.
        </p>
        <div className="rounded-sm overflow-hidden border border-white/10 mb-8">
          <video controls preload="metadata" className="w-full aspect-video bg-black" data-testid={HOME.explainerVideo}>
            <source src={VIDEO_URL} type="video/mp4" />
          </video>
        </div>
        <Link to="/donate" data-testid={HOME.explainerDonateButton}>
          <Button size="lg" className="bg-[#4FD1C5] text-zinc-950 font-semibold rounded-none px-8 hover:bg-[#3fc0b4]">
            <Heart className="h-4 w-4 mr-2" /> Fuel What You Just Saw — Donate
          </Button>
        </Link>
      </div>
    </section>
  );
}
